"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _utilities = _interopRequireDefault(require("../../../utilities"));

var _Placepicker = _interopRequireDefault(require("../../Placepicker"));

var _Store = require("../../Store");

var _useFetch7 = _interopRequireDefault(require("../../Store/useFetch"));

var _constant = require("../../constant");

var _lodash = _interopRequireDefault(require("lodash"));

var _constant2 = require("@airasia/phoenix-components/components/Dropdown/constant");

var _utilities2 = require("./utilities");

var _PlacePickerWrapperCityGrouping = _interopRequireDefault(require("./PlacePickerWrapperCityGrouping.prototypes"));

var _constant3 = require("../constant");

var _utils = require("../utils");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var PlacePickerCityGroupingWrapper = function PlacePickerCityGroupingWrapper(props) {
  var _viewPortSizing;

  var inputId = props.inputId,
      theme = props.theme,
      viewport = props.viewport,
      environment = props.environment,
      endpointConfig = props.endpointConfig,
      locale = props.locale,
      updateOrigin = props.updateOrigin,
      updateDestination = props.updateDestination,
      isOriginStationValid = props.isOriginStationValid,
      isDestinationStationValid = props.isDestinationStationValid,
      qpSyncOrigin = props.qpSyncOrigin,
      qpSyncDestination = props.qpSyncDestination,
      qpSyncStations = props.qpSyncStations,
      openCalendarFromPlacePicker = props.openCalendarFromPlacePicker,
      originLabel = props.originLabel,
      destinationLabel = props.destinationLabel,
      translations = props.translations,
      fireGtm = props.fireGtm,
      showIconBackground = props.showIconBackground,
      gtmParameters = props.gtmParameters,
      originOrDestinationNotFoundEventHandler = props.originOrDestinationNotFoundEventHandler,
      setDestinationSelectedObjectFromProps = props.setDestinationSelectedObjectFromProps,
      preFill = props.preFill,
      setOriginSelectedObjFromProps = props.setOriginSelectedObjFromProps,
      enableTravelSearchService = props.enableTravelSearchService,
      enableSuggestion = props.enableSuggestion; // eslint-disable-next-line no-unused-vars

  var _useFetch = (0, _useFetch7.default)({
    url: "".concat((0, _utils.formatEndpointURL)((0, _utils.getEndpointURL)(endpointConfig, 'featureFlag'), environment)),
    method: _constant.HTTPS_METHOD.GET
  }, _constant3.ASYNC_DATA_KEYS.FEATURE_FLAG),
      _useFetch2 = (0, _slicedToArray2.default)(_useFetch, 2),
      featureFlag = _useFetch2[0],
      fetchFeatureFlag = _useFetch2[1];

  var originStationsData = (0, _react.useContext)(_Store.Context).store.originStationsData;

  var _useFetch3 = (0, _useFetch7.default)(null, _constant3.ASYNC_DATA_KEYS.NEAREST_AIRPORT),
      _useFetch4 = (0, _slicedToArray2.default)(_useFetch3, 2),
      nearestAirports = _useFetch4[0],
      fetchNearestAirports = _useFetch4[1];

  var _useFetch5 = (0, _useFetch7.default)(null, _constant3.ASYNC_DATA_KEYS.DESTINATION_STATIONS),
      _useFetch6 = (0, _slicedToArray2.default)(_useFetch5, 2),
      destinationStationsList = _useFetch6[0],
      fetchDestinationStations = _useFetch6[1];

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      destinationCode = _useState2[0],
      setDestinationCode = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      destinationObjectList = _useState4[0],
      setDestinationObjectList = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      originDefault = _useState6[0],
      setOriginDefault = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      originItem = _useState8[0],
      setOriginItem = _useState8[1];

  var _useState9 = (0, _react.useState)(null),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      destinationItem = _useState10[0],
      setDestinationItem = _useState10[1];

  var _useState11 = (0, _react.useState)(null),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      destinationDefault = _useState12[0],
      setDestinationDefault = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      recentSearches = _useState14[0],
      setRecentSearches = _useState14[1];

  var _useState15 = (0, _react.useState)(null),
      _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
      geoPoint = _useState16[0],
      setGeoPoint = _useState16[1]; // eslint-disable-next-line no-unused-vars


  var _useState17 = (0, _react.useState)(false),
      _useState18 = (0, _slicedToArray2.default)(_useState17, 2),
      nearestAirport = _useState18[0],
      setNearestAirport = _useState18[1];

  var _useState19 = (0, _react.useState)(null),
      _useState20 = (0, _slicedToArray2.default)(_useState19, 2),
      recentSearchResultMapping = _useState20[0],
      setRecentSearchResultMapping = _useState20[1];

  var _useState21 = (0, _react.useState)(null),
      _useState22 = (0, _slicedToArray2.default)(_useState21, 2),
      originCode = _useState22[0],
      setOriginCode = _useState22[1];

  var _useState23 = (0, _react.useState)(null),
      _useState24 = (0, _slicedToArray2.default)(_useState23, 2),
      originSelectedObject = _useState24[0],
      setOriginSelectedObject = _useState24[1];

  var _useState25 = (0, _react.useState)(null),
      _useState26 = (0, _slicedToArray2.default)(_useState25, 2),
      destinationSelectedObject = _useState26[0],
      setDestinationSelectedObject = _useState26[1];

  var _useState27 = (0, _react.useState)(null),
      _useState28 = (0, _slicedToArray2.default)(_useState27, 2),
      isRecentSearchMapping = _useState28[0],
      setIsRecentSearchMapping = _useState28[1];

  var _useState29 = (0, _react.useState)(false),
      _useState30 = (0, _slicedToArray2.default)(_useState29, 2),
      localeChangeDetected = _useState30[0],
      setLocaleChangeDetected = _useState30[1];

  var _useState31 = (0, _react.useState)(false),
      _useState32 = (0, _slicedToArray2.default)(_useState31, 2),
      isSwapStations = _useState32[0],
      setIsSwapStations = _useState32[1];

  var _useState33 = (0, _react.useState)(null),
      _useState34 = (0, _slicedToArray2.default)(_useState33, 2),
      destCodeToSwap = _useState34[0],
      setDestCodeToSwap = _useState34[1];

  var _useState35 = (0, _react.useState)(null),
      _useState36 = (0, _slicedToArray2.default)(_useState35, 2),
      destObjectToSwap = _useState36[0],
      setDestObjectToSwap = _useState36[1];

  var _useState37 = (0, _react.useState)(true),
      _useState38 = (0, _slicedToArray2.default)(_useState37, 2),
      qpDestination = _useState38[0],
      setQpDestination = _useState38[1];

  var _useState39 = (0, _react.useState)(false),
      _useState40 = (0, _slicedToArray2.default)(_useState39, 2),
      airportServiceFlag = _useState40[0],
      setAirportServiceFlag = _useState40[1];

  var originRef = (0, _react.useRef)(null);
  var destinationRef = (0, _react.useRef)(null);
  var dropdownLabel = {
    noResultLabel: translations.data[0].noResultLabel,
    loadOptions: translations.data[0].loadOptions,
    recentSearch: recentSearches ? translations.data[0].recentSearchLabel : translations.data[0].nearestAirportLabel,
    allAirports: translations.data[0].allAirports || _constant2.ALL_AIRPORTS
  };

  var setCode = function setCode(data) {
    var code = data && data.StationType === _constant2.CITY_CODE ? data.CityCode : data.StationCode;
    return code;
  };

  var viewPortSizing = (_viewPortSizing = {}, (0, _defineProperty2.default)(_viewPortSizing, _constant.DEVICE_TYPE.MOBLE, '100%'), (0, _defineProperty2.default)(_viewPortSizing, _constant.DEVICE_TYPE.WEB, '352px'), _viewPortSizing);
  (0, _react.useEffect)(function () {
    if (!featureFlag) {
      return;
    }

    if (!featureFlag.data) {
      return;
    }

    if (!featureFlag.data || !featureFlag.data.configuration) {
      return;
    }

    if (featureFlag.data.configuration.ENABLE_AIRPORT_SEARCH_SERVICE) {
      setAirportServiceFlag(featureFlag.data.configuration.ENABLE_AIRPORT_SEARCH_SERVICE.toLowerCase() === 'true');
    }
  }, [featureFlag]);
  (0, _react.useEffect)(function () {
    setLocaleChangeDetected(true);
  }, [locale]);

  var fireGtmEvent = function fireGtmEvent(destinationValue) {
    var originCodeGtm = originSelectedObject && originSelectedObject.StationCode;
    var destinationCodeGtm = destinationValue.StationCode;
    var originTagGtm = originSelectedObject && (0, _utils.findGtmTag)(originSelectedObject.iconName);
    var destinationTagGtm = (0, _utils.findGtmTag)(destinationValue.iconName);
    var carrierTagGtm = (0, _utils.findCarrierGtmTag)(destinationValue.Provider);
    var obj = {
      event: 'trackEventNoEcommerce',
      'eventDetails.category': 'hpsearchwidget',
      'eventDetails.action': "click",
      // eslint-disable-next-line max-len
      'eventDetails.label': "".concat(gtmParameters.appName, " | ").concat(originCodeGtm, " - ").concat(destinationCodeGtm, " | ").concat(originTagGtm, " - ").concat(destinationTagGtm, " | ").concat(carrierTagGtm)
    };
    if (obj && fireGtm) fireGtm(obj, 'true');
  }; // FLIGHT-3457 New GTM event


  var fireDropdownClickGtmEvent = function fireDropdownClickGtmEvent() {
    var obj = {
      event: 'trackEventNoEcommerce',
      'eventDetails.category': 'hpsearchwidget',
      'eventDetails.action': "click",
      'eventDetails.label': gtmParameters.appName
    };
    if (obj && fireGtm) fireGtm(obj, 'true');
  }; // eslint-disable-next-line react-hooks/exhaustive-deps


  var setDestinationStationStates = function setDestinationStationStates(val) {
    // let code = val.StationCode ? val.StationCode : val.CityCode;
    if (val) {
      var code = setCode(val);
      setDestinationDefault(val);
      setDestinationSelectedObjectFromProps(val);
      setDestinationCode(code);
      setDestinationSelectedObject(val);
      updateDestination(code, val);
      fireGtmEvent(val);
    }
  };

  var fireGTMEditOrigin = function fireGTMEditOrigin(category, label) {
    var editOriginObj = {
      event: _constant3.GTM_EVENT.TRACK_EVENT_NO_ECOMMERCE,
      'eventDetails.category': category,
      'eventDetails.action': _constant3.GTM_ACTION.CLICK,
      'eventDetails.label': label
    };
    (0, _constant3.fireGtmEventForLabel)(editOriginObj);
  };

  var fireGTMEditDest = function fireGTMEditDest(category, label) {
    var editDestObj = {
      event: _constant3.GTM_EVENT.TRACK_EVENT_NO_ECOMMERCE,
      'eventDetails.category': category,
      'eventDetails.action': _constant3.GTM_ACTION.CLICK,
      'eventDetails.label': label
    };
    (0, _constant3.fireGtmEventForLabel)(editDestObj);
  };

  var DESTINATION_ON_SELECT_HANDLER = function DESTINATION_ON_SELECT_HANDLER(val) {
    var destination;
    destination = val.StationType === _constant3.FILTER_TYPE.STATION_KEY ? val.AirportName : val.StationName;
    var label;
    var category;

    if (val.AAFlight === true) {
      category = "".concat(_constant3.FLIGHTS, " | ").concat(destination, " | ").concat(_constant3.GTM_CATEGORIES.FLIGHT_SEARCH_WIDGETS);

      if (val.StationType === _constant3.FILTER_TYPE.STATION_KEY) {
        label = "".concat(destination, " | ").concat(_constant3.AIRPORT, " | ").concat(_constant3.GTM_TAGS.AA, " | ").concat(_constant3.GTM_LABELS.NEAREST_AIRPORT_CLICK_DEST_CITY);
      } else {
        label = "".concat(destination, " | ").concat(_constant3.CITY, " | ").concat(_constant3.GTM_TAGS.AA, " | ").concat(_constant3.GTM_LABELS.FLIGHT_SEARCH_WIDGET_CLICK_DEST_CITY);
      }
    } else {
      category = "".concat(_constant3.FLYBEYOND, " | ").concat(destination, " | ").concat(_constant3.GTM_CATEGORIES.FLIGHT_SEARCH_WIDGETS);

      if (val.StationType === _constant3.FILTER_TYPE.STATION_KEY) {
        label = "".concat(destination, " | ").concat(_constant3.AIRPORT, " | ").concat(_constant3.GTM_TAGS.OTA, " | ").concat(_constant3.GTM_LABELS.NEAREST_AIRPORT_CLICK_DEST_CITY);
      } else {
        label = "".concat(destination, " | ").concat(_constant3.AIRPORT, " | ").concat(_constant3.GTM_TAGS.OTA, " | ").concat(_constant3.GTM_LABELS.FLYBEYOND_WIDGET_CLICK_DEST_CITY);
      }
    }

    setDestinationStationStates(val);
    if (viewport === 'desktop') openCalendarFromPlacePicker(true);
    fireGTMEditDest(category, label);
  };

  (0, _react.useEffect)(function () {
    if (nearestAirports) {
      if (!nearestAirports.isFetching && !nearestAirports.isError) {
        try {
          if (Object.keys(nearestAirports.data).length > 0) {
            if (!preFill) {
              var nearestAirportList = [];

              if (enableTravelSearchService) {
                nearestAirportList = nearestAirports.data.airport.map(function (cityCode) {
                  return (0, _utilities2.getStationObjectFromCode)(cityCode, originStationsData.data, false);
                });
                var duplicateCities = (0, _utilities2.findDuplicateInStrOfArr)(nearestAirportList.map(function (item) {
                  return item.CityCode;
                }));
                var hasSameCity = !!duplicateCities.length;

                if (hasSameCity) {
                  var commonCityObj = (0, _utilities2.getStationObjectFromCode)(duplicateCities[0], originStationsData.data, true);
                  nearestAirportList = [commonCityObj].concat(nearestAirportList);
                }
              } else {
                nearestAirportList = nearestAirports.data.airport.map(function (cityCode, index) {
                  return (0, _utilities2.getStationObjectFromCode)(cityCode, originStationsData.data, index === 0);
                });
              }

              if (nearestAirportList) {
                nearestAirportList = nearestAirportList.filter(function (n) {
                  return n;
                });
                var res = (0, _utilities2.addNearestAirportLocationIcon)((0, _utilities2.parseSuggestions)(nearestAirportList));

                if (res && res[0]) {
                  var code = setCode(res[0]);
                  setOriginCode(code);
                  setOriginSelectedObjFromProps(res[0]);
                  setOriginDefault(res[0]);
                  setOriginSelectedObject(res[0]);
                  setOriginItem(res);
                  updateOrigin(code, res[0]);
                }
              }
            }

            setGeoPoint(nearestAirports.data.latlong);
          }
        } catch (err) {// just log message
          // No Logic here
        }
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [nearestAirports, originStationsData]);
  (0, _react.useEffect)(function () {
    fetchNearestAirports({
      url: (0, _utils.formatEndpointURL)((0, _utils.getEndpointURL)(endpointConfig, 'nearestAirport'), environment),
      method: _constant.HTTPS_METHOD.GET
    });
  }, []);
  (0, _react.useEffect)(function () {
    if (!qpSyncStations) {
      var recentSearch = (0, _utilities2.getRecentSearches)();

      if (!recentSearch) {
        setNearestAirport(true);
      } else {
        setIsRecentSearchMapping(true);
        setRecentSearches(true);
      }
    } else {
      setIsRecentSearchMapping(true);
      setRecentSearches(true);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  (0, _react.useEffect)(function () {
    if (recentSearches) {
      var recentSearch = (0, _utilities2.getRecentSearches)();

      if (recentSearch && recentSearch.length > 0) {
        var recentSearchesObject = {};

        for (var i = 0; i < recentSearch.length; i++) {
          var data = recentSearch[i].route;

          if (data && data.origin && data.destination) {
            var isOrigCity = !!(data && data.isOriginCity); // formatting : origin code / identifier if code is city or station

            var key = "".concat(data.origin.toUpperCase(), "/").concat(isOrigCity);
            recentSearchesObject[key] = Object.prototype.hasOwnProperty.call(recentSearchesObject, key) ? recentSearchesObject[key] : [];
            var isDestiCity = !!(data && data.isDestinationCity);
            recentSearchesObject[key].push("".concat(data.destination.toUpperCase(), "/").concat(isDestiCity));
          }
        }

        setRecentSearchResultMapping(recentSearchesObject);
      }
    }
  }, [recentSearches]);
  (0, _react.useEffect)(function () {
    if (recentSearchResultMapping) {
      if (originStationsData) {
        if (!originStationsData.isFetching && !originStationsData.isError) {
          var recentChangesOrigin = Object.keys(recentSearchResultMapping).map(function (code) {
            return (0, _utilities2.getStationObjectFromCode)(code, originStationsData.data);
          });
          recentChangesOrigin = (0, _utilities2.addRecentSearchLabelIcon)((0, _utilities2.parseSuggestions)(recentChangesOrigin));

          if (recentChangesOrigin && recentChangesOrigin.length > 0) {
            if (isRecentSearchMapping && recentChangesOrigin[0]) {
              var value = recentChangesOrigin[0];
              setOriginDefault(value);
              setOriginSelectedObjFromProps(value);
              var code = setCode(value);
              setOriginCode(code);
              setOriginSelectedObject(value);
              updateOrigin(code, value);
            }

            setOriginItem(recentChangesOrigin);
          }
        }
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [recentSearchResultMapping, originStationsData]);

  var ORIGIN_ON_SELECT_HANDLER = function ORIGIN_ON_SELECT_HANDLER(val) {
    var code = val.StationCode ? val.StationCode : val.CityCode;
    setOriginCode(code);
    var origin;
    origin = val.StationType === _constant3.FILTER_TYPE.STATION_KEY ? val.AirportName : val.StationName;
    var label;
    var category;

    if (val.AAFlight === true) {
      category = "".concat(_constant3.FLIGHTS, " | ").concat(origin, " | ").concat(_constant3.GTM_CATEGORIES.FLIGHT_SEARCH_WIDGETS);

      if (val.StationType === _constant3.FILTER_TYPE.STATION_KEY) {
        label = "".concat(origin, " | ").concat(_constant3.AIRPORT, " | ").concat(_constant3.GTM_TAGS.AA, " | ").concat(_constant3.GTM_LABELS.NEAREST_AIRPORT_CLICK_ORIGIN_CITY);
      } else {
        label = "".concat(origin, " | ").concat(_constant3.CITY, " | ").concat(_constant3.GTM_TAGS.AA, " | ").concat(_constant3.GTM_LABELS.FLIGHT_SEARCH_WIDGET_CLICK_ORIGIN_CITY);
      }
    } else {
      category = "".concat(_constant3.FLYBEYOND, " | ").concat(origin, " | ").concat(_constant3.GTM_CATEGORIES.FLIGHT_SEARCH_WIDGETS);

      if (val.StationType === _constant3.FILTER_TYPE.STATION_KEY) {
        label = "".concat(origin, " | ").concat(_constant3.AIRPORT, " | ").concat(_constant3.GTM_TAGS.OTA, " | ").concat(_constant3.GTM_LABELS.NEAREST_AIRPORT_CLICK_ORIGIN_CITY);
      } else {
        label = "".concat(origin, " | ").concat(_constant3.CITY, " | ").concat(_constant3.GTM_TAGS.OTA, " | ").concat(_constant3.GTM_LABELS.FLYBEYOND_SEARCH_WIDGET_CLICK_ORIGIN_CITY);
      }
    }

    setOriginCode(val.StationCode);
    setOriginDefault(val);
    setOriginSelectedObjFromProps(val);
    setOriginSelectedObject(val);
    setDestinationCode(null);
    setDestinationDefault(null);
    setDestinationSelectedObject(null);
    setDestinationSelectedObjectFromProps(null);
    setIsRecentSearchMapping(false);
    updateOrigin(code, val);
    updateDestination(null, null); // if (code !== originCode) setDestinationItem(null);

    if (val.StationCode !== originCode) setDestinationItem(null);
    fireGTMEditOrigin(category, label);
  };

  (0, _react.useEffect)(function () {
    if (destinationStationsList) {
      if (!destinationStationsList.isFetching && !destinationStationsList.isError) {
        var destinationAirportList = (0, _utilities2.getDestinationAirportsList)(destinationStationsList.data);
        var apiDestObject = JSON.parse(JSON.stringify(originStationsData.data));
        var destinationAirportsObject = (0, _utilities2.getDestinationAirportsObject)(apiDestObject, destinationAirportList, originSelectedObject.StationType);
        setDestinationObjectList(destinationAirportsObject);

        if (recentSearchResultMapping) {
          // if (Object.prototype.hasOwnProperty.call(recentSearchResultMapping, originCode)) {
          // fetch the most recent code that matches the originCode; returns undefined if none
          var codeValue = Object.keys(recentSearchResultMapping).filter(function (str) {
            return str.includes(originCode);
          }).pop();

          if (codeValue) {
            var recentSearch = (0, _utilities2.getRecentSearches)();
            var destinationRecentSearches = (0, _utilities2.getRecentCodeData)(codeValue, recentSearch, _constant3.DESTINATION_KEY, _constant3.ORIGIN);

            if (destinationRecentSearches) {
              if (isRecentSearchMapping && destinationRecentSearches) {
                setDestinationDefault(destinationRecentSearches);
                var code = setCode(destinationRecentSearches);
                setDestinationCode(code);
                setDestinationSelectedObjectFromProps(destinationRecentSearches);
                setDestinationSelectedObject(destinationRecentSearches);
                updateDestination(code, destinationRecentSearches);
              } // If destinationRecentSearches is object, add it inside an array since destinationItems is expecting an array


              if ((0, _typeof2.default)(destinationRecentSearches) === 'object') {
                setDestinationItem([destinationRecentSearches]);
              } else {
                setDestinationItem(destinationRecentSearches);
              }
            }
          } else {
            setDestinationItem(null);
          }
        }

        if (qpSyncDestination && qpDestination) {
          var isDC = preFill && preFill.isDC;
          var value = "".concat(qpSyncDestination, "/").concat(isDC);
          var destinationObject = (0, _utilities2.getStationObjectFromCode)(value, destinationAirportsObject);

          if (destinationObject) {
            var formattedDestination = (0, _utilities2.formatStationObject)(destinationObject);

            if (formattedDestination) {
              setDestinationDefault(formattedDestination);

              var _code = setCode(formattedDestination);

              setDestinationCode(_code);
              setDestinationSelectedObject(formattedDestination);
              setDestinationSelectedObjectFromProps(formattedDestination);
              updateDestination(_code, formattedDestination);
              setQpDestination(false);
            }
          }
        }

        if (isSwapStations) {
          var newDestinationStation = (0, _utilities2.getStationObjectFromCode)(destCodeToSwap, destinationAirportsObject);

          var _formattedDestination = (0, _utilities2.formatStationDisplayName)(_objectSpread(_objectSpread({}, destObjectToSwap), newDestinationStation));

          if (_formattedDestination) {
            setDestinationStationStates(_formattedDestination);
          } else {
            setDestinationDefault(null);
            setDestinationCode(null);
            setDestinationSelectedObject(null);
            setDestinationSelectedObjectFromProps(null);
            updateDestination(null, null);
          }

          setIsSwapStations(false);
        }
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [destinationStationsList]);
  (0, _react.useEffect)(function () {
    if (originSelectedObject) {
      var url = (0, _utils.formatEndpointURL)((0, _utils.getEndpointURL)(endpointConfig, 'destinationCity'), environment);
      fetchDestinationStations({
        url: "".concat(url + originSelectedObject.Dest, "/file.json"),
        method: _constant.HTTPS_METHOD.GET
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [endpointConfig, environment, fetchDestinationStations, originCode]);
  (0, _react.useEffect)(function () {
    if (originStationsData) {
      if (!originStationsData.isFetching && !originStationsData.isError) {
        if (qpSyncOrigin) {
          var isOC = preFill && preFill.isOC;
          var value = "".concat(qpSyncOrigin, "/").concat(isOC);
          var originObj = (0, _utilities2.getStationObjectFromCode)(value, originStationsData.data);

          if (originObj) {
            var formattedOrigin = (0, _utilities2.formatStationObject)(originObj);

            if (formattedOrigin) {
              var code = setCode(formattedOrigin);
              setOriginCode(code);
              setOriginDefault(formattedOrigin);
              setOriginSelectedObjFromProps(formattedOrigin);
              setOriginSelectedObject(formattedOrigin);
              updateOrigin(code, formattedOrigin);
              updateDestination(null, null);
            }
          }
        }

        if (localeChangeDetected) {
          if (originCode && originSelectedObject) {
            var url = (0, _utils.formatEndpointURL)((0, _utils.getEndpointURL)(endpointConfig, 'destinationCity'), environment);
            fetchDestinationStations({
              url: "".concat(url + originSelectedObject.Dest, "/file.json"),
              method: _constant.HTTPS_METHOD.GET
            });

            var _value = setCode(originSelectedObject);

            var translatedOriginStationObject = (0, _utilities2.getStationObjectFromCode)(_value, originStationsData.data);

            var _formattedOrigin = (0, _utilities2.formatStationDisplayName)(_objectSpread(_objectSpread({}, originSelectedObject), translatedOriginStationObject));

            if (_formattedOrigin) {
              var origCode = setCode(_formattedOrigin);
              setOriginCode(origCode);
              setOriginDefault(_formattedOrigin);
              setOriginSelectedObjFromProps(_formattedOrigin);
              setOriginSelectedObject(_formattedOrigin);
              updateOrigin(origCode, _formattedOrigin);
            }
          }

          if (destinationCode && destinationSelectedObject) {
            var destiCode = setCode(destinationSelectedObject);
            var translatedDestinationStationObject = (0, _utilities2.getStationObjectFromCode)(destiCode, originStationsData.data);
            var formattedDestination = (0, _utilities2.formatStationDisplayName)(_objectSpread(_objectSpread({}, destinationSelectedObject), translatedDestinationStationObject));

            if (formattedDestination) {
              setDestinationDefault(formattedDestination);

              var _code2 = setCode(formattedDestination);

              setDestinationCode(_code2);
              setDestinationSelectedObjectFromProps(formattedDestination);
              setDestinationSelectedObject(formattedDestination);
              updateDestination(_code2, formattedDestination);
            }
          }

          setLocaleChangeDetected(false);
        }
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [endpointConfig, environment, fetchNearestAirports, originStationsData]);

  var fetchDestinationData = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(value, selectedOrigin, selectedStationType) {
      var baseAirportSearchUrl, airportSearchUrl, headers, data;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              baseAirportSearchUrl = (0, _utils.formatEndpointURL)((0, _utils.getEndpointURL)(endpointConfig, 'airportSearch'), environment);
              airportSearchUrl = "".concat(baseAirportSearchUrl, "/search/airports?locale=").concat(locale, "&query=").concat(encodeURIComponent(value));

              if (selectedOrigin) {
                airportSearchUrl += "&origin=".concat(encodeURIComponent(selectedOrigin));
              }

              if (selectedStationType === 'C') {
                airportSearchUrl += "&isCity=true";
              }

              if (geoPoint) {
                airportSearchUrl += "&geoPoint=".concat(encodeURIComponent(geoPoint));
              }

              headers = {
                'Content-Type': 'application/json'
              };
              _context.next = 8;
              return _utilities.default.get(airportSearchUrl, headers);

            case 8:
              data = _context.sent;
              return _context.abrupt("return", data);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchDestinationData(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();

  var originOnchangeHandler = _lodash.default.debounce( /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(value, callback) {
      var suggestions, obj;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (originStationsData.data == null) {
                callback('');
              }

              if (!(enableTravelSearchService || airportServiceFlag)) {
                _context2.next = 16;
                break;
              }

              _context2.prev = 2;
              _context2.next = 5;
              return fetchDestinationData(value);

            case 5:
              suggestions = _context2.sent;
              _context2.next = 14;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](2);
              console.error('Failed to fetch destination data:', _context2.t0);
              _context2.next = 13;
              return (0, _utilities2.filteredSuggestion)(value, originStationsData.data);

            case 13:
              suggestions = _context2.sent;

            case 14:
              _context2.next = 19;
              break;

            case 16:
              _context2.next = 18;
              return (0, _utilities2.filteredSuggestion)(value, originStationsData.data);

            case 18:
              suggestions = _context2.sent;

            case 19:
              // if null fire gtm event for origin not found
              if (value && !suggestions.length) {
                obj = {
                  event: 'trackEventNoEcommerce',
                  'eventDetails.category': 'hpsearchwidget|not found',
                  'eventDetails.action': 'error',
                  'eventDetails.label': "".concat(value, "|origin")
                };

                if (originOrDestinationNotFoundEventHandler) {
                  originOrDestinationNotFoundEventHandler(obj);
                }
              }

              callback(suggestions);

            case 21:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 8]]);
    }));

    return function (_x4, _x5) {
      return _ref2.apply(this, arguments);
    };
  }(), 200);

  var destinationOnchangeHandler = _lodash.default.debounce( /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(value, callback) {
      var suggestions, obj;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (destinationObjectList == null) {
                callback('');
              }

              if (!(enableTravelSearchService || airportServiceFlag)) {
                _context3.next = 16;
                break;
              }

              _context3.prev = 2;
              _context3.next = 5;
              return fetchDestinationData(value, originSelectedObject.StationCode, originSelectedObject.StationType);

            case 5:
              suggestions = _context3.sent;
              _context3.next = 14;
              break;

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](2);
              console.error('Failed to fetch destination data:', _context3.t0);
              _context3.next = 13;
              return (0, _utilities2.filteredSuggestion)(value, destinationObjectList);

            case 13:
              suggestions = _context3.sent;

            case 14:
              _context3.next = 19;
              break;

            case 16:
              _context3.next = 18;
              return (0, _utilities2.filteredSuggestion)(value, destinationObjectList);

            case 18:
              suggestions = _context3.sent;

            case 19:
              // if null fire gtm event for destination not found
              if (value && !suggestions.length) {
                obj = {
                  event: 'trackEventNoEcommerce',
                  'eventDetails.category': 'hpsearchwidget|not found',
                  'eventDetails.action': 'error',
                  'eventDetails.label': "".concat(value, "|destination")
                };

                if (originOrDestinationNotFoundEventHandler) {
                  originOrDestinationNotFoundEventHandler(obj);
                }
              }

              callback(suggestions);

            case 21:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[2, 8]]);
    }));

    return function (_x6, _x7) {
      return _ref3.apply(this, arguments);
    };
  }(), 200);

  var isDestinationValid = function isDestinationValid(bool) {
    if (!bool) {
      setDestinationCode(null);
      setDestinationDefault(null);
      updateDestination(null, null);
    }

    isDestinationStationValid(bool);
  };

  var isOriginValid = function isOriginValid(bool) {
    if (!bool) {
      setOriginCode(null);
      setOriginSelectedObject(null);
      setOriginDefault(null);
      setOriginSelectedObjFromProps(null);
      setDestinationCode(null);
      setDestinationObjectList(null);
      setDestinationDefault(null);
      setDestinationItem(null);
      updateOrigin(null, null);
      updateDestination(null, null);
    }

    isOriginStationValid(bool);
  };

  var isCity = function isCity(selectedObject) {
    return selectedObject && (selectedObject.isCity || selectedObject.StationType === _constant2.CITY_CODE);
  };

  var onSwapCallback = function onSwapCallback() {
    if (destinationCode && destinationSelectedObject) {
      var isDC = isCity(destinationSelectedObject);
      var destiCode = "".concat(destinationCode, "/").concat(isDC);
      var originNew = (0, _utilities2.getStationObjectFromCode)(destiCode, originStationsData.data);
      var formattedOrigin = (0, _utilities2.formatStationDisplayName)(_objectSpread(_objectSpread({}, destinationSelectedObject), originNew));

      if (formattedOrigin) {
        var code = setCode(formattedOrigin);
        setOriginCode(code);
        setOriginDefault(formattedOrigin);
        setOriginSelectedObject(formattedOrigin);
        setOriginSelectedObjFromProps(null);
        updateOrigin(code, formattedOrigin);
        var isOC = isCity(originSelectedObject);
        var oriCode = "".concat(originCode, "/").concat(isOC);
        setDestCodeToSwap(oriCode);
        setDestObjectToSwap(originSelectedObject);
        setIsSwapStations(true);
      }
    }
  };

  return /*#__PURE__*/_react.default.createElement(_Placepicker.default, {
    inputId: inputId,
    theme: theme,
    viewPort: viewport,
    originOnchange: originOnchangeHandler,
    destinationOnchange: destinationOnchangeHandler,
    originOnselect: ORIGIN_ON_SELECT_HANDLER,
    destinationOnselect: DESTINATION_ON_SELECT_HANDLER,
    defaultDestination: destinationDefault,
    defaultOrigin: originDefault,
    originItems: originItem,
    destinationItems: destinationItem,
    locale: dropdownLabel,
    originPlaceholder: _constant2.PLACEHOLDER.ORIGIN,
    destinationPlaceholder: _constant2.PLACEHOLDER.DESTINATION,
    width: viewPortSizing[viewport],
    originLabel: originLabel,
    destinationLabel: destinationLabel,
    originIcon: _constant2.DEFAULT_ICON,
    destinationIcon: _constant2.DEFAULT_ICON,
    supportOneCharacterSearch: true,
    originRef: originRef,
    destinationRef: destinationRef,
    isOriginValid: isOriginValid,
    isDestinationValid: isDestinationValid,
    onSwapcallback: onSwapCallback,
    qpSyncStations: qpSyncStations,
    customProperties: {
      id: 'flight-place-picker'
    },
    dropdownOnClickCallback: fireDropdownClickGtmEvent,
    showIconBackground: showIconBackground,
    cityLevelGrouping: true,
    enableSuggestion: enableSuggestion
  });
};

PlacePickerCityGroupingWrapper.propTypes = _PlacePickerWrapperCityGrouping.default.PropTypes;
PlacePickerCityGroupingWrapper.defaultProps = _PlacePickerWrapperCityGrouping.default.DefaultProps;
var _default = PlacePickerCityGroupingWrapper;
exports.default = _default;